import Link from 'next/link'

import { Button } from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import { CODA_FORM_CONTACT_US, HELP_URL, LEGAL_NAME, WHATSAPP_LINK } from '@helper/utils/core'
import cn from '@config/tailwind/cn'

const footerSections = [
  {
    title: 'Sumber Daya',
    links: [
      { label: 'Inspirasi Mengajar', href: '/blog/teaching-strategy', target: '_self' },
      { label: 'Pelatihan Guru', href: 'https://akademi.bacapibo.com/', target: '_blank' },
      { label: 'Program beasiswa', href: '/blog/impact-report', target: '_self' },
    ],
  },
  {
    title: 'Dukungan',
    links: [
      { label: 'Pusat Bantuan', href: HELP_URL, target: '_blank' },
      { label: 'Tanya & Kolaborasi', href: CODA_FORM_CONTACT_US, target: '_blank' },
      { label: 'Kontak Bantuan', href: WHATSAPP_LINK, target: '_blank' },
    ],
  },
  {
    title: 'Pernyataan',
    links: [
      { label: 'Ketentuan Layanan', href: '/syarat-dan-ketentuan', target: '_self' },
      { label: 'Kebijakan Privasi', href: '/kebijakan-privasi', target: '_self' },
    ],
  },
]

export function Footer() {
  return (
    <footer className='bg-neutral-black w-full p-8'>
      <div className='mx-auto flex w-full max-w-300 flex-col gap-6'>
        <div className='flex flex-wrap gap-6'>
          {footerSections.map((section) => (
            <div key={section.title} className='flex w-50 flex-col'>
              <span className={cn(typographyVariants({ variant: 'title-sm' }), 'text-grey-100')}>{section.title}</span>
              <div className='flex flex-col justify-start'>
                {section.links.map((link) => (
                  <Button
                    key={link.label}
                    variant='ghost'
                    size='sm'
                    asChild
                    className={cn(typographyVariants({ variant: 'label-sm' }), 'text-blue-10 justify-start')}
                  >
                    <Link href={link.href} target={link.target}>
                      {link.label}
                    </Link>
                  </Button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className='border-outline flex flex-wrap justify-between gap-4 border-t py-2'>
          <span className={cn(typographyVariants({ variant: 'body-md' }), 'text-blue-10 flex h-7.5 items-center')}>
            © {LEGAL_NAME}
          </span>
          <iframe
            src='https://status.bacapibo.com/badge?theme=dark'
            height='30'
            frameBorder='0'
            scrolling='no'
            style={{ colorScheme: 'normal', width: '100%', maxWidth: '190px' }}
          />
        </div>
      </div>
    </footer>
  )
}
